/** localStorage draft for /otherbrands (previous smoking brand). */
export const OTHER_BRANDS_STORAGE_KEY = 'npdsurvey:otherBrands';

/** Brand value when the respondent specifies a brand not listed in the catalog. */
export const PREV_BRAND_OTHERS = 'Others';

export type OtherBrandsAnswers = {
  brand: string;
  variant: string;
};

export function isOthersPrevBrandBrand(brand: string): boolean {
  return brand.trim().toLowerCase() === PREV_BRAND_OTHERS.toLowerCase();
}

/** Normalizes draft answers so "Others" free-text is always brand=Others, variant=<specify>. */
export function buildOtherBrandsAnswers(brand: string, variant: string): OtherBrandsAnswers {
  const trimmedVariant = variant.trim();
  if (isOthersPrevBrandBrand(brand)) {
    return { brand: PREV_BRAND_OTHERS, variant: trimmedVariant };
  }
  return { brand: brand.trim(), variant: trimmedVariant };
}

export function readOtherBrandsAnswers(): Partial<OtherBrandsAnswers> | null {
  try {
    const raw = localStorage.getItem(OTHER_BRANDS_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as unknown;
    if (typeof parsed !== 'object' || parsed === null) return null;
    const p = parsed as Record<string, unknown>;
    return {
      brand: typeof p.brand === 'string' ? p.brand : '',
      variant: typeof p.variant === 'string' ? p.variant : '',
    };
  } catch {
    return null;
  }
}

export function writeOtherBrandsAnswers(data: OtherBrandsAnswers): void {
  try {
    localStorage.setItem(
      OTHER_BRANDS_STORAGE_KEY,
      JSON.stringify(buildOtherBrandsAnswers(data.brand, data.variant))
    );
  } catch {
    /* ignore */
  }
}

export function clearOtherBrandsAnswers(): void {
  try {
    localStorage.removeItem(OTHER_BRANDS_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isOtherBrandsComplete(): boolean {
  const s = readOtherBrandsAnswers();
  return !!s?.brand?.trim() && !!s?.variant?.trim();
}
